import { LayoutDashboard, Calendar, UserCheck, Users } from 'lucide-react';
import { useDateFilter } from '~/hooks/useDateFilter';
import { useDashboardData } from '~/hooks/useDashboardData';
import { DateFilterBar } from '~/components/DateFilterBar';
import { MetricCard } from '~/components/MetricCard';
import { FormFilterTabs } from '~/components/FormFilterTabs';
import { FormActivityTable } from '~/components/FormActivityTable';
import { PerformanceChart } from '~/components/PerformanceChart';

export const Dashboard = () => {
  const { preset, setPreset, dateRange } = useDateFilter('all');
  const {
    loading,
    stats,
    forms,
    selectedFormId,
    setSelectedFormId,
    activityPage,
    setActivityPage,
    activityRows,
    activityTotal,
    performance,
  } = useDashboardData(dateRange);

  const selectedForm = forms.find((f) => f.id === selectedFormId);

  if (loading && !stats) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <div className="p-6 space-y-8">
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <LayoutDashboard className="h-6 w-6 text-foreground" />
          <h1 className="text-2xl font-bold">Dashboard</h1>
        </div>
      </div>

      {/* Date filter */}
      <DateFilterBar value={preset} onChange={setPreset} />

      {/* Overview section */}
      <section>
        <h2 className="text-lg font-semibold mb-4">Overview</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <MetricCard title="Meetings Booked" value={stats?.meetingsBooked ?? 0} icon={Calendar} />
          <MetricCard title="Contacts Created" value={stats?.contactsCreated ?? 0} icon={UserCheck} />
          <MetricCard title="Leads Captured" value={stats?.leadsCaptured ?? 0} icon={Users} />
        </div>
      </section>

      {/* Form Activity section */}
      <section>
        <h2 className="text-lg font-semibold mb-4">Form Activity</h2>
        <div className="mb-4">
          <FormFilterTabs forms={forms} selectedFormId={selectedFormId} onSelect={setSelectedFormId} />
        </div>
        <FormActivityTable
          rows={activityRows}
          total={activityTotal}
          page={activityPage}
          onPageChange={setActivityPage}
          selectedForm={selectedForm}
        />
      </section>

      {/* Performance section */}
      <section>
        <PerformanceChart data={performance} />
      </section>
    </div>
  );
};
